import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { getTimeFromUTCToTimezone } from 'shared/utils/getTimeFromUTCToTimezone';

dayjs.extend(customParseFormat);
export class AgentAdminConverter {
  convertNotifications(data) {
    return data
      .map(item => {
        return {
          id: item.id,
          date: item.created_at
            ? getTimeFromUTCToTimezone(dayjs(item.created_at, 'YYYY-MM-DDTHH:mm:ss.ssssss')).format(
                'DD.MM.YYYY HH:mm:ss',
              )
            : null,
          type: item?.type,
          amount: item?.amount,
          fromId: item?.from_id,
          currency: item?.currency,
          notification: item.notification,
        };
      })
      .sort(
        (a, b) =>
          dayjs(b.date, 'DD.MM.YYYY HH:mm:ss').toDate().valueOf() -
          dayjs(a.date, 'DD.MM.YYYY HH:mm:ss').toDate().valueOf(),
      )
      .valueOf();
  }
}
